import { List } from './List';

// TODO: in v9, move styled() from List.jsx to here
export var StyledList = List;